import React from 'react'
import Layout from '../components/Layout'
import { Image, Breadcrumb } from 'antd'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

const About = () => {
  return (
    <>
      <Helmet>
        <title>เกี่ยวกับโรงพยาบาล | โรงพยาบาลจริยธรรมรวมแพทย์กระบี่</title>
        <meta name='description' content='โรงพยาบาลจริยธรรมรวมแพทย์กระบี่ โรงพยาบาลชั้นนำในจังหวัดกระบี่ บริการด้วยแพทย์มากประสบการณ์ ทีมงานผู้เชี่ยวชาญพร้อมเทคโนโลยี เครื่องมือทันสมัย ด้วยมาตรฐานระดับโลก' />
      </Helmet>

      <Layout>
        <div className='about__container'>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to='/'>หน้าหลัก</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ color: '#666' }}>
              เกี่ยวกับโรงพยาบาล
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className='about'>
            <div className='about__image'>
              <Image
                preview={false}
                width={'100%'}
                height='auto'
                alt='about-image'
                src={require('../images/about/empty.jpg')}
              />
            </div>

            <div className='about__info'>
              <h1>ประวัติโรงพยาบาล</h1>

              <div>
                <p className='about__info-text'>โรงพยาบาลจริยธรรมรวมแพทย์กระบี่ เป็นโรงพยาบาลเอกชนขนาด 25 เตียง อยู่ที่ 529 ถนนอุตรกิจ ตำบล กระบี่ใหญ่ อำเภอ เมืองกระบี่ จังหวัดกระบี่81000 โทรศัพท์ 0-7566-4455 โทรสาร 0-7566-4144 มีประวัติความเป็นมา ดังนี้</p>
                <p className='about__info-text'>ปี พ.ศ.2514 นายแพทย์ประทิน สุนทเรกานนท์ ได้ก่อตั้งโรงพยาบาลแห่งนี้ขึ้นในนามของ “โรงพยาบาลรวมแพทย์กระบี่” ซึ่งเป็นโรงพยาบาลเอกชนแห่งแรกของจังหวัดกระบี่ เป็นอาคารพาณิชย์ 1 คูหาจำนวน 16 เตียง มีพนักงานประมาณ 30 คน มีการขยายตัวอาคารเพิ่มขึ้น แต่ล้มเลิกกิจการไป เมื่อนายแพทย์ประทิน สุนทเรกานนท์ ได้เสียชีวิตลง</p>
                <p className='about__info-text'>ต่อมามีการร่วมระดมทุนเพื่อเปิดกิจการใหม่ โดยการนำของคุณดีน เกียรติตรง ร่วมกับนายแพทย์ แวมะหะดี แวดาโอะ และนายแพทย์มูนีร์สมูฮัมหมัด ใบกาเด็ม โดยใช้ชื่อว่า “โรงพยาบาลจริยธรรมรวมแพทย์กระบี่” โดยนำแนวคิดหลักธรรมศาสนาอิสลามมาขับเคลื่อนให้เป็นโรงพยาบาลเอกชนแห่งแรกที่บริหารจัดการโดยมุสลิมเพื่อประโยชน์สูงสุดแก่สังคมโดยรวม</p>
                <p className='about__info-text'>ในปี พ.ศ.2543 นายแพทย์มูนีร์สมูฮัมหมัด ใบกาเด็ม ได้เชิญบุคคลที่มีจิตสาธารณะเข้ามาร่วมลงทุน โดยนำหลักธรรมคำสอนของศาสนาอิสลามมาเป็นแนวทางในการดำเนินงาน โดยมีจุดเน้นที่จะรักษาและบริการคนไข้เพื่อแสวงหาความโปรดปรานของอัลลอฮฺ มิใช่มุ่งหวังผลกำไรในโลกนี้เป็นสำคัญ การบริหารเป็นแบบ “ธุรกิจเชิงสงเคราะห์” โดยที่ผู้ป่วยสามารถเข้าถึงการบริการทางการแพทย์อย่างเท่าเทียมกัน ฉันเครือญาติ (We all are brothers) มีการริเริ่มโครงการช่วยเหลือสังคมหลากหลายโครงการ เช่น ให้การสงเคราะห์เด็กกำพร้าและผู้ยากไร้ มอบอาหารแก่ผู้ยากไร้ โครงการรอมฎอนแบ่งปัน มอบทุนการศึกษา เป็นต้น ด้วยความตระหนักถึงแนวคิดดังกล่าว โรงพยาบาลจึงได้จัดตั้ง “กองทุนเด็กกำพร้าและผู้ยากไร้” ขึ้นเพื่อช่วยเหลือค่ารักษาพยาบาลแก่ผู้ป่วยที่ขัดสน ด้วยปณิธานที่ว่า “เราจะดูแลกัน” เพราะเราเป็นพี่น้องกัน อันเป็นคำสอนของศาสนาอิสลามและมีการเพิ่มจำนวนเตียงเป็น 25 เตียง เพื่อรองรับจำนวนผู้รับบริการได้มากขึ้น</p>
                <p className='about__info-text'>ในปี 2557 นายแพทย์มูนีร์สมูฮัมหมัด ใบกาเด็ม ได้เสียชีวิตลง นายรอเฉด ใบกาเด็ม จึงเข้ามาบริหารงานต่อ โดยยึดหลักการตามที่นายแพทย์มูนีร์ส ได้วางไว้</p>
                <p className='about__info-text'>ในปี 2560 นายแพทย์พันธุ์เทพ ฉิมหาด ดำรงตำแหน่งผู้อำนวยการโรงพยาบาล</p>
                <p className='about__info-text'>ในปี 2564 นางสาวเซาวลา สมานประธาน ดำรงตำแหน่งผู้อำนวยการโรงพยาบาล</p>
                <p className='about__info-text'>ในปี 2566 ดร.ศิดดิก ลาลีวัน ดำรงตำแหน่งผู้อำนวยการ</p>
                <p className='about__info-text'>โดยผู้บริหารในปัจจุบันได้มีการปรับเปลี่ยนวิสัยทัศน์ และพันธกิจ เพื่อให้ตอบสนองการให้บริการแก่ผู้รับบริการในยุคสมัยปัจจุบัน ตลอดจนยังคงมีการจัดกิจกรรมช่วยเหลือสังคม ดังคำขวัญของโรงพยาบาลคือ <i><b>“เรา…จะดูแลกัน Like Family We Care”</b></i></p>
                <p className='about__info-text'>นอกจากนี้เพื่อให้โรงพยาบาลมีมาตรฐานเป็นที่ยอมรับอย่างกว้างขวาง ผู้บริหารจึงให้ยังคงการได้รับการรับรองระบบมาตรฐานคุณภาพ ISO 9001:2015 ไว้ เพื่อให้การบริการด้านต่างๆ ของโรงพยาบาลมีมาตรฐานเป็นประโยชน์สูงสุดต่อองค์กรต่อบุคลากร โดยเฉพาะต่อผู้รับบริการ (Patient Focus) ต่อไป</p>
              </div>
            </div>
          </div>

          <div className='vision'>
            <div className='vision__image'>
              <Image
                preview={false}
                width={'100%'}
                height='auto'
                alt='vision-image'
                src={require('../images/about/empty.jpg')}
              />
            </div>

            <div className='vision__info'>
              <h1>วิสัยทัศน์ และพันธกิจ</h1>

              <div>
                <b>วิสัยทัศน์</b>
                <p>
                  โรงพยาบาลฮาลาลชั้นนำที่มีมาตรฐานสากล ยึดหลักจริยธรรม
                  รักษาผู้ป่วยอย่างเท่าเทียม
                  โดยใช้เทคโนโลยีและนวัตกรรมทางการแพทย์ที่ทันสมัย
                </p>

                <b>พันธกิจ</b>
                <p>1.พัฒนาระบบโรงพยาบาลให้สอดคล้องตามมาตรฐานสากล</p>
                <p>2.ให้บริการและรักษาพยาบาลด้วยความเสมอภาคและเท่าเทียมกัน</p>
                <p>3.พัฒนาระบบเทคโนโลยีและนวัตกรรมทางการแพทย์</p>
                <p>
                  4.พัฒนาบุคลากรให้มีสมรรถนะเพียงพอ มีความสุข
                  และเป็นองค์กรแห่งการเรียนรู้
                </p>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  )
}

export default About
